import { Input } from 'reactstrap';
import { useEffect, useState } from 'react';

export default function SelectForm(props) {
    const [selected, setSelected] = useState({ property_id:"", property_item_id:"" });


    const handleSelectOptionClick = (e) => {
        setSelected({...selected, property_id: e.target.id, property_item_id: e.target[e.target.selectedIndex].value })
        props.handleSelectOption(e.target.id, e.target[e.target.selectedIndex].value);
    }

    useEffect(() => {
        if( props.properties && props.properties.length > 0){
            var resualt = props.properties.find((element) => element.property_id === props.data.id);
            if( resualt) {
                setSelected({property_id: resualt.property_id, property_item_id: resualt.property_item_id })
            }
        }
    },[]);

  return (
    <>
        <Input 
            required={props.data.is_force && true}
            onFocus={props.handleFocus}
            onBlur={props.handleBlur}
            invalid={props.isValid}
            id={props.data.id} 
            name='properties'
            value={selected.property_item_id}
            type='select' 
            placeholder='Choose ...' 
            onChange={handleSelectOptionClick}
            >
            <option disabled value="">Choose ...</option>
        {
            props.data.property_items.map((option) => (
                <option key={`${option.value}-${option.id}`} id={option.id} value={option.id} >
                    {option.value}
                </option>
            ))
            }
        </Input>
    </>
  )
}
